module.exports = __webpack_public_path__ + "img/蒙版分组 (4).c80789d3.png";